import { createFileRoute, redirect } from '@tanstack/react-router'
import { WithNavigation } from '../../components/Layouts.tsx'
import { Restricted } from '../../components/Restricted.tsx'
import { Stack } from '../../components/Stack.tsx'
import { DownloadAlertsCSV } from '../../features/panel/DownloadAlertsCSV.tsx'
import { ReportsTable } from '../../features/reports/table/ReportsTable.tsx'

export const Route = createFileRoute('/_app/reports/')({
	component: RouteComponent,
	beforeLoad: ({ context: { isAdmin, isLimitedAdmin, sub, impersonation } }) => {
		if ((!isAdmin && !isLimitedAdmin) || (!impersonation && !sub.features.includes('analyze'))) {
			throw redirect({ to: '/' })
		}
	},
})

function RouteComponent() {
	return (
		<WithNavigation
			topBar={
				<Stack justify='end' align='center' flexGrow={1}>
					<Restricted feature='protections'>
						<DownloadAlertsCSV variant='text' />
					</Restricted>
				</Stack>
			}
		>
			<ReportsTable />
		</WithNavigation>
	)
}
